import { render, staticRenderFns } from "./PersonaList.vue?vue&type=template&id=eb53609c&"
import script from "./PersonaList.vue?vue&type=script&lang=js&"
export * from "./PersonaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports